<template>
  <el-col style="width: 98%; margin: 0 auto" v-loading="ifLoading">
    <el-form :inline="true" :model="formroom" class="demo-form-inline">
      <el-form-item label="会议室名称">
        <el-input
          v-model="formroom.name"
          clearable
          size="small"
          placeholder="会议室名称"
        />
      </el-form-item>
      <el-form-item label="会议室地址">
        <el-select
          v-model="formroom.address_id"
          size="small"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(ad, index) in addressList"
            :key="index"
            :label="ad.address"
            :value="ad.id"
            >{{ ad.city }},{{ ad.address }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="可容纳人数">
        <el-input
          v-model="formroom.number"
          clearable
          size="small"
          placeholder="会议人数"
        />
      </el-form-item>
      <el-form-item label="会议设备">
        <el-select
          v-model="formroom.equipment_id"
          multiple
          size="small"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="(ad, index) in Equipmentlist"
            :key="index"
            :label="ad.equipment_name"
            :value="ad.id"
            >{{ ad.equipment_name }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-card
      v-for="(item, index) in room"
      :key="index"
      shadow="always"
      style="margin-top: 10px"
    >
      <el-col class="meetingCard">
        <el-row>
          <el-col :md="24" :lg="24" :xl="6">
            <el-row class="cente" style="margin-top: 10px">
              <el-col :span="8" style="min-width: 100px; max-width: 150px">
                <el-image
                  :src="item.avatar"
                  :preview-src-list="item.pictures"
                  style="width: 100px; height: 100px"
                />
              </el-col>
              <el-col :span="16" @click.native="go(item)">
                <span>
                  <span class="roomName" @click="go(item)">{{ item.name }}</span>&nbsp;&nbsp;&nbsp;
                  <span>可容纳{{ item.capacity }}人</span>
                </span>
                <p>会议地点：{{ item.room_address.city }}{{ item.room_address.address }} - {{ item.area }}</p>
                <p>管理员：{{ item.room_admin_name }}({{ item.room_admin_workcode }}) - {{ item.telephone }}</p>
                <el-tag
                  v-for="(items, index) in item.equipments"
                  :key="index"
                  type="info"
                  size="small"
                  effect="plain"
                  style="margin-left: 5px"
                  >{{ items.equipment_name }}</el-tag
                >
              </el-col>
            </el-row>
            <div @click="go(item)">
              <el-button
                type="primary"
                size="small"
                style="margin-top: 50px"
                @click="go(item)"
                >立即预约</el-button
              >
            </div>
          </el-col>
          <el-col :xl="1">
            <div style="width: 100%; height: 1px" />
          </el-col>
          <el-col :md="24" :lg="24" :xl="17" style="overflow: auto;">
            <meeting-time :roomid="item.id" :isList="true"/>
          </el-col>
        </el-row>
      </el-col>
    </el-card>
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :page-sizes="[2, 5, 10, 30, 50]"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'
import meetingTime from '@/components/meetingTime'
import { parseTime } from '@/utils/index'
import { meetingroom } from '@/api/conferencebooking'
import { searchAddress } from '@/api/city'
import { searchEquipment } from '@/api/equipment'
export default {
  components: {
    meetingTime
  },
  data() {
    return {
      ifLoading: false,
      newdata: '',
      addressList: [],
      Equipmentlist: [],
      pageSize: 2,
      page: 1,
      form: {},
      total: 0,
      room: [],
      formroom: {
        name: '',
        address_id: null,
        equipment_id: null,
        number: null,
        page: 1,
        page_size: 2
      }
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  created() {
    const nowDate = new Date().getTime()
    const formateDate = parseTime(nowDate).split(' ')[1]
    const formateTime = formateDate.substr(0, 5).split(':')
    this.newdata = Number(formateTime[0] + formateTime[1])
    searchAddress().then(response => {
      console.log(response)
      this.addressList = response.data.address
    }).catch(err => {
      console.log(err)
    })
    searchEquipment().then(response => {
      console.log(response)
      this.Equipmentlist = response.data.equipment.equipments
    }).catch(err => {
      console.log(err)
    })
    this.getmeetingroom(this.formroom)
  },
  methods: {
    go(item) {
      this.$router.push({
        name: 'appointment',
        query: {
          id: item.id
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getmeetingroom()
    },
    getmeetingroom() {
      const data = {
        name: this.formroom.name,
        address_id: Number(this.formroom.address_id) || '',
        equipment_id: Number(this.formroom.equipment_id) || '',
        number: Number(this.formroom.number) || '',
        page: this.page,
        page_size: this.pageSize
      }
      this.ifLoading = true
      meetingroom(data).then(response => {
        this.ifLoading = false
        this.room = response.data.rooms
        this.total = response.data.pagination.total
      }).catch(err => {
        console.log(err)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.getmeetingroom()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getmeetingroom()
    }
  }
}
</script>
<style style lang="scss" scope>
.roomName {
  font-size: 18px;
}
.meetingCard {
  font-size: 14px;
  color: #606266;
}
.footer {
  border-top: 1px solid #ebeef5;
}

.bg {
  background: rebeccapurple !important;
}

ul {
  padding: 0;
  margin: 0;
}

.demo-form-inline {
  margin-top: 10px;
}

.index {
  background: red;
}
</style>
